// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--2kF0q","anchor":"Button-module--anchor--dRb-f"};